module.exports = __webpack_public_path__ + "img/rocket.8cca24c0.svg";